var exports = {
  "kL": "xe564cbfb--284980--container",
  "DD": "xe564cbfb--284980--title",
  "NQ": "xe564cbfb--284980--features-list",
  "h_": "xe564cbfb--284980--description",
  "Xt": "xe564cbfb--284980--internal-banner",
};

module.exports = exports;
